/**
 * Celeste Dice Color Schemes
 *
 * Color-specific schemes for the celeste dice design.
 * Each color defines a solid outer fill and a 3-stop gradient for the inner diamond.
 */

export interface CelesteDiceColorScheme {
  /** Unique name used as gradient ID prefix to avoid SVG collisions */
  name: string;
  /** Solid fill for the outer diamond star */
  outerFill: string;
  /** 3-stop linear gradient for the inner diamond star [start, mid, end] */
  innerGradient: [string, string, string];
}

export const CELESTE_DICE_COLOR_SCHEMES: Record<string, CelesteDiceColorScheme> = {
  blue: {
    name: 'blue',
    outerFill: '#1C0A89',
    innerGradient: ['#5FACD6', '#4584C7', '#3B57A1']
  },
  red: {
    name: 'red',
    outerFill: '#750000',
    innerGradient: ['#CE6161', '#C14848', '#BC2A2A']
  },
  yellow: {
    name: 'yellow',
    outerFill: '#D3A04F',
    innerGradient: ['#FECB70', '#FDE58F', '#FEF5B2']
  },
  green: {
    name: 'green',
    outerFill: '#067200',
    innerGradient: ['#61D166', '#47C447', '#30BF28']
  }
};
